import React from 'react'
import './copyright.component.css'

const Copyright = () => {
  return (
    <div className='copyright'>Copyright ©2025 All rights reserved</div>
  )
}

export default Copyright